import {createSlice} from '@reduxjs/toolkit';
const initialState = {
  branches: [],
  currentBranch: null,
  random: null,
  connection: null,
  listLoading: false,
  actionsLoading: false,
  error: null,
  ipAddress:null
};
export const callTypes = {
  list: 'list',
  action: 'action',
};

export const globalSlice = createSlice({
  name: 'global',
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    setRandom: (state, action) => {
      state.random = Math.random().toString(32);
    },
    setBranches: (state, action) => {
      state.branches = action.payload;
    },
    setCurrentBranch: (state, action) => {
      state.currentBranch = action.payload;
    },

    setConnection: (state, action) => {
      state.connection = action.payload;
    },    
    
    setIpAddress: (state, action) => {
      state.ipAddress = action.payload;
    },
  },
});
